import * as React from 'react';

const CreateHeader: React.FC<CreateHeaderProps> = ({ children }) => <div className="create-header">{children}</div>;

interface CreateHeaderProps {
    children: React.ReactNode;
}

export default CreateHeader;
